import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { SLLayer } from '../sl-layer';
import { CancellablePromise } from 'src/app/types/cancellable-promise';
import { GeometryObject } from '@turf/turf';

@Injectable({
	providedIn: 'root'
})
export class FeatureService {

	constructor(private wapi: SlWapiService) {
	}

	GetGeoJSON(layer: SLLayer, featureId: number | string): CancellablePromise {
		const data: any = {};
		if (layer.isPLayer === true) {
			data.plid = layer.identifier;
		} else {
			data.lid = layer.identifier;
		}
		data.featureId = featureId;
		return this.wapi.Post('features/feature/get_geojson', data);
	}
	SaveGeoJSON(layer: SLLayer, geometry: GeometryObject, featureId: number | string = null): CancellablePromise {
		const data: any = {};
		if (layer.isPLayer === true) {
			data.plid = layer.identifier;
		} else {
			data.lid = layer.identifier;
		}
		if (featureId !== null) {
			data.featureId = featureId;
		}
		data.idField = 'gid';
		data.geojson_geom = JSON.stringify(geometry);

		return this.wapi.Post('features/feature/save', data);
	}
	UpdateFeature(layer: SLLayer, featureId: number = null, feature: any): CancellablePromise {
		const data: any = {};
		if (layer.isPLayer === true) {
			data.plid = layer.identifier;
		} else {
			data.lid = layer.identifier;
		}
		if (featureId !== null) {
			data.featureId = featureId;
		}
		data.idField = 'gid';
		data.record = JSON.stringify(feature);
		return this.wapi.Post('features/feature/save', data);

	}
  DeleteFeature(layer:SLLayer,featureId:number|string):CancellablePromise {
    return this.wapi.Post('features/feature/delete',{"layer":layer.id,"featureId":featureId});
  }

}
